import React from 'react'
import Work from '../components/technology/Work';

const Technology = () => {
  return (
    <div>
        <section className="bg-image pt-40 pb-40">
            <div className="container">
                <h2 className="wow fadeInUp" data-wow-duration="1.2s" data-wow-delay=".2s">Technologies</h2>
               
            </div>
        </section>
        <Work/>
    </div>
  )
}

export default Technology